import * as types from "./types";
import {
    getDepartmentListAxios,
    deleteDepartmentAxios,
    postDepartmentAxios,
    putDepartmentAxios,
    getDepartmentByIDAxios
} from "./services";

export async function getDepartmentListAction({ commit }) {
    commit(types.LOADING_DEPARTMENT, true);
    try {
        const { data } = await getDepartmentListAxios();
        commit(types.GET_DEPARTMENT_LIST, data.result.data);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_DEPARTMENT, false);
    }
}

export async function removeDepartmentAction({ commit }, payload) {
    commit(types.LOADING_DEPARTMENT, true);
    try {
        await deleteDepartmentAxios(payload);
        commit(types.REMOVE_DEPARTMENT, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_DEPARTMENT, false);
    }
}

export async function addDepartmentAction({ commit }, payload) {
    commit(types.LOADING_DEPARTMENT, true);
    try {
        await postDepartmentAxios(payload);
        commit(types.ADD_DEPARTMENT, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_DEPARTMENT, false);
    }
}

export async function updateDepartmentAction({ commit }, payload) {
    commit(types.LOADING_DEPARTMENT, true);
    try {
        await putDepartmentAxios(payload);
        commit(types.UPDATE_DEPARTMENT, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_DEPARTMENT, false);
    }
}


export async function getDepartmentByIDAction({commit}, payload) {
    commit(types.LOADING_DEPARTMENT, true);
    try {
        
        const {data} = await getDepartmentByIDAxios(payload);
        commit(types.GET_DEPARTMENTBYID, data.result);
    }
    catch(e) {
        throw e;
    }
    finally {
        commit(types.LOADING_DEPARTMENT, false);
    }
   
}